// src/App.vue
<template>
  <router-view />
</template>